export const LIST_TOOLBAR_SEARCH_PLACEHOLDER = "Buscar";
export const LIST_TOOLBAR_SEARCH_CLEAR_LABEL = "Limpar busca";
